/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Theme = exports.PrivacyPolicyType = exports.ButtonPosition = exports.Audience = void 0;
var Audience;
(function (Audience) {
    Audience["all_visitors"] = "all_visitors";
    Audience["eu_visitors"] = "eu_visitors";
})(Audience = exports.Audience || (exports.Audience = {}));
var ButtonPosition;
(function (ButtonPosition) {
    ButtonPosition["bottom_right"] = "bottom_right";
    ButtonPosition["bottom_left"] = "bottom_left";
    ButtonPosition["center_right"] = "center_right";
    ButtonPosition["center_left"] = "center_left";
})(ButtonPosition = exports.ButtonPosition || (exports.ButtonPosition = {}));
var PrivacyPolicyType;
(function (PrivacyPolicyType) {
    PrivacyPolicyType["page_on_site"] = "page_on_site";
    PrivacyPolicyType["external_url"] = "external_url";
})(PrivacyPolicyType = exports.PrivacyPolicyType || (exports.PrivacyPolicyType = {}));
var Theme;
(function (Theme) {
    Theme["light"] = "light";
    Theme["dark"] = "dark";
    Theme["custom"] = "custom";
})(Theme = exports.Theme || (exports.Theme = {}));
//# sourceMappingURL=types.js.map